(() => {
  const openButtons = document.querySelectorAll('[data-sf-search-open]');
  const modal = document.querySelector('[data-sf-search-modal]');
  const close = document.querySelector('[data-sf-search-close]');
  openButtons.forEach(button => button.addEventListener('click', () => modal?.classList.add('is-open')));
  close?.addEventListener('click', () => modal?.classList.remove('is-open'));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') modal?.classList.remove('is-open');
  });

  /* Repeat the source set until it always fills the viewport. Moving exactly
     one source-set width makes every loop restart on the same logo. */
  const setupBrandMarquees = () => {
    document.querySelectorAll('[data-sf-brand-track]').forEach(track => {
      const viewport = track.closest('.sf-brands-viewport');
      const set = track.querySelector('[data-sf-brand-set]');
      if (!viewport || !set) return;

      track.querySelectorAll('[data-sf-brand-clone]').forEach(clone => clone.remove());
      const setWidth = set.getBoundingClientRect().width;
      if (!setWidth) return;

      track.style.setProperty('--sf-marquee-distance', `${setWidth}px`);
      while (track.scrollWidth < viewport.clientWidth + setWidth) {
        const clone = set.cloneNode(true);
        clone.setAttribute('data-sf-brand-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.append(clone);
      }
    });
  };

  setupBrandMarquees();
  window.addEventListener('resize', () => window.requestAnimationFrame(setupBrandMarquees));

  const menuToggle = document.querySelector('[data-sf-menu-toggle]');
  const mobileMenu = document.querySelector('[data-sf-mobile-menu]');
  const searchToggle = document.querySelector('[data-sf-mobile-search-toggle]');
  const mobileSearch = document.querySelector('[data-sf-mobile-search]');
  const siteHeader = document.querySelector('[data-sf-site-header]');

  const togglePanel = (button, panel, otherButton, otherPanel) => {
    if (!button || !panel) return;
    const willOpen = panel.hidden;
    panel.hidden = !willOpen;
    button.setAttribute('aria-expanded', String(willOpen));
    if (willOpen && otherPanel) {
      otherPanel.hidden = true;
      otherButton?.setAttribute('aria-expanded', 'false');
    }
  };

  menuToggle?.addEventListener('click', () => togglePanel(menuToggle, mobileMenu, searchToggle, mobileSearch));
  searchToggle?.addEventListener('click', () => {
    togglePanel(searchToggle, mobileSearch, menuToggle, mobileMenu);
    if (!mobileSearch?.hidden) mobileSearch.querySelector('input')?.focus();
  });
  window.addEventListener('scroll', () => siteHeader?.classList.toggle('is-scrolled', window.scrollY > 15), { passive: true });

  const escapeHtml = value => String(value).replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[character]);
  const recentKey = 'satfeek-recent-products';
  const readRecentProducts = () => {
    try { return JSON.parse(localStorage.getItem(recentKey) || '[]'); } catch { return []; }
  };
  const saveRecentProduct = product => {
    const products = readRecentProducts().filter(item => item.url !== product.url);
    products.unshift(product);
    localStorage.setItem(recentKey, JSON.stringify(products.slice(0, 5)));
  };

  document.querySelectorAll('[data-sf-predictive-search]').forEach(root => {
    const input = root.querySelector('[data-sf-search-input]');
    const mobileInput = root.querySelector('[data-sf-mobile-search-input]');
    const toggle = root.querySelector('[data-sf-search-toggle]');
    const panel = root.querySelector('[data-sf-search-results]');
    const label = root.querySelector('[data-sf-search-label]');
    const list = root.querySelector('[data-sf-search-list]');
    const endpoint = root.dataset.predictiveUrl;
    let timer;

    const draw = (products, title, emptyMessage = 'No matching products found.') => {
      label.textContent = title;
      list.innerHTML = products.length ? products.map(product => `<a class="sf-search-result" href="${escapeHtml(product.url)}" data-sf-result data-title="${escapeHtml(product.title)}" data-price="${escapeHtml(product.price || '')}" data-image="${escapeHtml(product.image || '')}">${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : '<span></span>'}<span><strong>${escapeHtml(product.title)}</strong>${product.price ? `<span>${escapeHtml(product.price)}</span>` : ''}</span></a>`).join('') : `<p class="sf-search-empty">${emptyMessage}</p>`;
      panel.hidden = false;
    };

    const showRecent = () => draw(readRecentProducts(), 'Recent searches', 'Your recently opened search products will appear here.');
    const findProducts = async query => {
      try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('section_id', 'predictive-search');
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        draw(products.map(product => ({ title: product.title, url: product.url, image: product.image, price: product.price })), 'Products');
      } catch { draw([], 'Products', 'Search is temporarily unavailable.'); }
    };

    const handleSearchInput = searchInput => {
      searchInput.addEventListener('focus', () => searchInput.value.trim() ? findProducts(searchInput.value.trim()) : showRecent());
      searchInput.addEventListener('input', () => {
        window.clearTimeout(timer);
        const query = searchInput.value.trim();
        if (!query) { showRecent(); return; }
        timer = window.setTimeout(() => findProducts(query), 180);
      });
    };
    if (input) handleSearchInput(input);
    if (mobileInput) handleSearchInput(mobileInput);
    toggle?.addEventListener('click', () => {
      if (window.matchMedia('(min-width: 1024px)').matches) { input?.focus(); return; }
      showRecent();
      mobileInput?.focus();
    });
    list?.addEventListener('click', event => {
      const result = event.target.closest('[data-sf-result]');
      if (!result) return;
      saveRecentProduct({ title: result.dataset.title, url: result.getAttribute('href'), price: result.dataset.price, image: result.dataset.image });
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) panel.hidden = true; });
  });

  document.querySelectorAll('[data-sf-product-tabs]').forEach(tabGroup => {
    const tabs = [...tabGroup.querySelectorAll('[data-sf-tab]')];
    const panels = [...tabGroup.querySelectorAll('[data-sf-panel]')];
    const activate = selected => {
      tabs.forEach(tab => {
        const active = tab === selected;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.sfPanel !== selected.dataset.sfTab; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        activate(tabs[next]);
      });
    });
  });

  document.querySelectorAll('[data-sf-product-purchase]').forEach(purchase => {
    const form = purchase.querySelector('form');
    const quantity = purchase.querySelector('input[name="quantity"]');
    const minus = purchase.querySelector('[data-sf-quantity-minus]');
    const plus = purchase.querySelector('[data-sf-quantity-plus]');
    const variantSelect = purchase.querySelector('[data-sf-variant-select]');
    const currentPrice = purchase.querySelector('[data-sf-current-price]');
    const comparePrice = purchase.querySelector('[data-sf-compare-price]');
    const submit = purchase.querySelector('.sf-product-purchase__submit');
    const submitLabel = purchase.querySelector('[data-sf-submit-label]');

    minus?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    plus?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
    quantity?.addEventListener('change', () => { quantity.value = Math.max(1, Number(quantity.value || 1)); });

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      currentPrice.textContent = option.dataset.price;
      comparePrice.textContent = option.dataset.comparePrice;
      comparePrice.hidden = option.dataset.onSale !== 'true';
      submit.disabled = !available;
      submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
    });
  });

  /* Add Satfeek products with Shopify's Cart AJAX API. This keeps shoppers on
     the same page instead of following the normal /cart/add redirect. */
  const renderCartCount = itemCount => {
    /* Dawn does not render a count bubble at all when the cart begins empty.
       Create one in that case, then update it immediately after every add. */
    document.querySelectorAll('.header__icon--cart').forEach(cartLink => {
      let bubble = cartLink.querySelector('.cart-count-bubble');
      if (!bubble && itemCount > 0) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden">items in cart</span>';
        cartLink.append(bubble);
      }
      if (!bubble) return;

      const count = bubble.querySelector('[aria-hidden="true"]');
      if (count) count.textContent = itemCount;
      bubble.hidden = itemCount === 0;
    });
  };

  const displayedCartCount = () => {
    const count = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
    return Number(count?.textContent || 0) || 0;
  };

  const refreshCartCount = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    /* The header badge represents distinct products, not total quantities. */
    renderCartCount(cart.items.length);
    return cart;
  };

  const showCartToast = () => {
    let toast = document.querySelector('[data-sf-cart-toast]');
    if (!toast) {
      const cartUrl = document.querySelector('.header__icon--cart')?.href || '/cart';
      toast = document.createElement('aside');
      toast.className = 'sf-cart-toast';
      toast.dataset.sfCartToast = '';
      toast.setAttribute('role', 'status');
      toast.innerHTML = `<span><span class="sf-cart-toast__status">Added</span><br>Product added to cart</span><a class="sf-cart-toast__link" href="${cartUrl}">View cart</a>`;
      document.body.append(toast);
    }
    window.clearTimeout(showCartToast.timeout);
    toast.classList.add('is-visible');
    showCartToast.timeout = window.setTimeout(() => toast.classList.remove('is-visible'), 3000);
  };

  /* Make the badge correct on first page load too, including carts with
     quantities greater than one for the same product. */
  refreshCartCount();

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.sfAdding === 'true') return;

    event.preventDefault();
    form.dataset.sfAdding = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    const label = button?.querySelector('[data-sf-submit-label], .sf-button > span:first-child');
    const originalLabel = label?.textContent;
    if (button) button.disabled = true;

    try {
      const formData = new FormData(form);
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cartBefore = cartResponse.ok ? await cartResponse.json() : null;
      const variantId = String(formData.get('id') || '');
      const productAlreadyExists = cartBefore?.items?.some(item => String(item.variant_id || item.id) === variantId);
      const countBeforeAdd = cartBefore?.items?.length ?? displayedCartCount();
      renderCartCount(countBeforeAdd + (productAlreadyExists ? 0 : 1));
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error('Unable to add item');
      await refreshCartCount();
      if (label) label.textContent = 'Added to cart';
      showCartToast();
      window.setTimeout(() => { if (label && originalLabel) label.textContent = originalLabel; }, 1400);
    } catch {
      await refreshCartCount();
      if (label) label.textContent = 'Try again';
      window.setTimeout(() => { if (label && originalLabel) label.textContent = originalLabel; }, 1800);
    } finally {
      window.setTimeout(() => {
        if (button) button.disabled = false;
        delete form.dataset.sfAdding;
      }, 350);
    }
  }, true);

  const initialiseCatalogue = root => {
    const requestUpdate = async form => {
      const parameters = new URLSearchParams(new FormData(form));
      const baseUrl = new URL(form.action, window.location.origin);
      baseUrl.search = parameters.toString();
      const requestUrl = new URL(baseUrl);
      requestUrl.searchParams.set('section_id', root.dataset.sfCatalogue);
      root.classList.add('is-updating');
      try {
        const response = await fetch(requestUrl.toString(), { headers: { Accept: 'text/html' } });
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const replacement = documentFragment.querySelector('[data-sf-catalogue]');
        if (!replacement) throw new Error('Catalogue section not returned');
        const nextRoot = replacement;
        root.replaceWith(nextRoot);
        window.history.pushState({}, '', baseUrl);
        initialiseCatalogue(nextRoot);
      } catch {
        window.location.assign(baseUrl);
      }
    };

    const filters = root.querySelector('[data-sf-catalogue-filters]');
    const controls = root.querySelector('[data-sf-catalogue-controls]');
    const filterToggle = root.querySelector('[data-sf-filter-toggle]');

    filterToggle?.addEventListener('click', () => {
      const isOpen = filters.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(isOpen));
      filterToggle.textContent = isOpen ? 'Hide filters' : 'Show filters';
    });

    filters?.addEventListener('submit', event => { event.preventDefault(); requestUpdate(filters); });
    filters?.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.addEventListener('change', () => requestUpdate(filters));
    });
    controls?.addEventListener('submit', event => { event.preventDefault(); requestUpdate(controls); });
    controls?.querySelector('select[name="sort_by"]')?.addEventListener('change', () => requestUpdate(controls));
  };
  document.querySelectorAll('[data-sf-catalogue]').forEach(initialiseCatalogue);

  document.querySelectorAll('[data-sf-countdown]').forEach(timer => {
    const end = new Date(timer.dataset.end).getTime();
    const draw = () => {
      const difference = Math.max(0, end - Date.now());
      const values = {
        days: Math.floor(difference / 86400000),
        hours: Math.floor(difference / 3600000) % 24,
        minutes: Math.floor(difference / 60000) % 60,
        seconds: Math.floor(difference / 1000) % 60
      };
      Object.entries(values).forEach(([key, value]) => {
        const target = timer.querySelector(`[data-sf-${key}]`);
        if (target) target.textContent = String(value).padStart(2, '0');
      });
    };
    draw();
    window.setInterval(draw, 1000);
  });
})();
